import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initTelegramWebApp } from "./integrations/telegram/telegramService";

// В некоторых окружениях Telegram WebView сторонние скрипты вызывают
// MutationObserver.observe раньше, чем DOM-узел готов. Это приводит к
// необработанной ошибке "Failed to execute 'observe'..." и блокирует загрузку.
// Патчим observe, чтобы пропускать некорректные вызовы и логировать предупреждение.
if (typeof window !== "undefined" && "MutationObserver" in window) {
  const originalObserve = window.MutationObserver.prototype.observe;
  const patchedObserve: typeof originalObserve = function observePatched(
    this: MutationObserver,
    target: Node,
    options: MutationObserverInit
  ): void {
    if (!(target instanceof Node)) {
      console.warn(
        "MutationObserver.observe пропущен: передан объект без типа Node",
        target
      );
      return;
    }
    originalObserve.call(this, target, options);
  };

  window.MutationObserver.prototype.observe = patchedObserve;
}

// Инициализируем Telegram WebApp, если приложение запущено в Telegram
if (window.Telegram && window.Telegram.WebApp) {
  console.log("window.Telegram", window.Telegram);
  console.log("window.Telegram.WebApp", window.Telegram.WebApp);
  console.log("window.Telegram.WebApp.initData", window.Telegram.WebApp.initData);
  console.log("window.Telegram.WebApp.initDataUnsafe", window.Telegram.WebApp.initDataUnsafe);
  initTelegramWebApp();
}

import "./i18n/config"; // Import i18n configuration

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <React.Suspense fallback="Loading...">
      <App />
    </React.Suspense>
  </React.StrictMode>
);
